/***********************************************************/
/*                                                         */
/*       **** See html2pfd docs for more info ***          */
/*   https://www.npmjs.com/package/html2pdf.js/v/0.9.0     */
/*                                                         */
/*     Add page breaks: className='html2pdf__page-break'   */
/*     Hide elements:  data-html2canvas-ignore="true"      */
/*                                                         */
/***********************************************************/

import React, { useState, useEffect } from "react";
import { DateTime } from "luxon";
import { FaDownload } from "react-icons/fa";
// import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
// import { storage } from "../services/firebaseConfig";
// import { getRandomString } from "../helpers/randomString";
import {
  convertNumberToWords,
  lawsByState,
} from "../helpers/leaseDataAndFunctions";
import { getOrdinalSuffix } from "../helpers/helperFunctions";

const LeasePDF = (props) => {
  const { lease, finalSignature } = props;
  const [isClickable, setIsClickable] = useState(true); // prevent multiple downloads
  // const [fileUploaded, setFileUploaded] = useState(false);

  const landlordName =
    lease.landlordFirstName +
    " " +
    (lease.landlordMiddleName ? lease.landlordMiddleName + " " : "") +
    lease.landlordLastName;

  const tenantName =
    lease.tenantFirstName +
    " " +
    (lease.tenantMiddleName ? lease.tenantMiddleName + " " : "") +
    lease.tenantLastName;

  const tenantInitials =
    lease.tenantFirstName[0] +
    "." +
    (lease.tenantMiddleName ? lease.tenantMiddleName[0] + "." : "") +
    lease.tenantLastName[0] +
    ".";

  const stateLawObj = lawsByState.find((x) => x.state === lease.propertyState);

  const handleDownload = async () => {
    const html2pdf = await require("html2pdf.js/dist/html2pdf.min.js");
    const options = {
      margin: 20,
      filename: `Lease Agreement_UNSIGNED_${lease.leaseStart}.pdf`,
    };

    const leaseHTML = document.getElementById("lease");
    await html2pdf().set(options).from(leaseHTML).save();
    // .outputPdf("blob"); // Generate the PDF as a blob
    // .then(async (blob) => {
    //   const metadata = {
    //     contentType: "application/pdf",
    //   };

    //   const fileRef = ref(
    //     storage,
    //     `leases/${lease.landlordUuid}/${getRandomString(20)}.pdf`
    //   );

    //   // upload file to cloud
    //   await uploadBytes(fileRef, blob, metadata).then(async (snapshot) => {
    //     await getDownloadURL(snapshot.ref).then((url) => {
    //       console.log(url);
    //     });
    //   });
    // });
    setIsClickable(true);
  };

  // useEffect(() => {
  //   if (finalSignature && !fileUploaded) handleUpload();
  // }, []);

  // const handleUpload = async () => {
  //   const html2pdf = await require("html2pdf.js/dist/html2pdf.min.js");
  //   const options = {
  //     margin: 20,
  //     filename: `Lease Agreement_${lease.leaseStart}.pdf`,
  //   };

  //   const leaseHTML = document.getElementById("lease");
  //   await html2pdf()
  //     .set(options)
  //     .from(leaseHTML)
  //     // .save()
  //     .outputPdf("blob") // Generate the PDF as a blob
  //     .then(async (blob) => {
  //       const metadata = {
  //         contentType: "application/pdf",
  //       };

  //       const fileRef = ref(
  //         storage,
  //         `leases/${lease.landlordUuid}/${lease.uuid}.pdf`
  //       );

  //       // upload file to cloud
  //       await uploadBytes(fileRef, blob, metadata).then(async (snapshot) => {
  //         await getDownloadURL(snapshot.ref).then((url) => {
  //           setFileUploaded(true);
  //           console.log(url);
  //         });
  //       });
  //     });
  // };

  useEffect(() => {
    if (finalSignature) {
      const element = document.getElementById("full-lease");
      element.scrollTop = element.scrollHeight;
    }
  }, []);

  return (
    <div id="full-lease" className={`w-screen h-screen overflow-y-scroll`}>
      {/* {!finalSignature && (
        <div
          className="fixed top-28 left-0 right-0 h-16 flex justify-end items-center
        bg-black bg-opacity-35"
          onClick={
            isClickable
              ? () => {
                  setIsClickable(false);
                  handleDownload();
                }
              : () => {}
          }
        >
          <div className="flex gap-x-2 hover:text-white cursor-pointer px-10">
            <FaDownload className="text-2xl" /> Download
          </div>
        </div>
      )} */}
      <div className={`flex justify-center ${finalSignature ? "" : "mt-10"}`}>
        <div id="lease" className="max-w-[800px] px-5 font-lease-2">
          <section>
            <div className="flex justify-center text-center text-3xl pt-10 pb-5">
              LEASE AGREEMENT
            </div>
          </section>
          <section className="pt-5">
            <span className="text-lg">I. TERM</span>
            <p className="pt-2">
              This legal document (“Hereinafter referred to as “Lease
              Agreement”) represents a lease agreement with a minimum term of{" "}
              {lease.leaseTerm}, to begin on{" "}
              <span className="underline">
                {DateTime.fromFormat(lease.leaseStart, "yyyy-MM-dd").toFormat(
                  "MMMM dd, yyyy"
                )}
              </span>{" "}
              and ending{" "}
              <span className="underline">
                {DateTime.fromFormat(lease.leaseEnd, "yyyy-MM-dd").toFormat(
                  "MMMM dd, yyyy"
                )}
              </span>
              , at 11:59pm. Following the end of the minimum term, the Lease
              Agreement will continue on a month-to-month basis. Once the
              minimum term has elapsed, the Landlord and Tenant may modify or
              terminate this Lease Agreement at ANYTIME by giving 30 days'
              written notice.
            </p>
          </section>
          <section className="pt-5">
            <span className="text-lg">II. LANDLORD & TENANT</span>
            <p className="pt-2">
              This Lease Agreement is between{" "}
              <span className="underline capitalize">{landlordName}</span>{" "}
              (Hereinafter referred to as “Landlord”), and{" "}
              <span className="underline capitalize">{tenantName}</span>{" "}
              (Hereinafter referred to as “Tenant”).
            </p>
          </section>
          <section className="pt-5">
            <span className="text-lg">III. PREMISES</span>
            <p className="pt-2">
              The Landlord agrees to lease the premises located at:
            </p>
            <div className="h-32 content-center my-5">
              <div className="grid justify-items-center capitalize">
                <div>{lease.roomName}</div>
                <div>{lease.propertyStreet}</div>
                <div>{lease.propertyStreet2}</div>
                <div>
                  {lease.propertyCity}, {lease.propertyState}{" "}
                  {lease.propertyZip}
                </div>
              </div>
            </div>
            <p>
              (Hereinafter referred to as the “Premises”) to the Tenant only for
              the purposes of residential use.{" "}
              {false && (
                <span>
                  The Landlord agrees to include furnishings and appliances as
                  described:
                </span>
              )}
              If there are any common areas for use but which are shared between
              other Tenants or the Landlord, Tenant shall have the every right
              to use said areas.{" "}
              {false && (
                <span>
                  If there are any restrictions on said common areas they are:
                </span>
              )}
            </p>
          </section>
          <section className="pt-5">
            <span className="text-lg">IV. USE</span>
            <div className="pt-2">
              The Tenant shall obey, and require anyone else on the Premises to
              obey, all laws and restrictions that apply to the Premises as well
              as any Federal or State Laws and act in a manner that does not
              unreasonably disturb any neighbors or constitute a breach of peace
              Landlord will give Tenant notice of any restrictions that apply to
              the Premises.
              <ul className="grid py-5 px-2 gap-y-2">
                <li className="">
                  A. Alterations - Tenant may not make alterations or
                  improvements to the Premises without first obtaining
                  permission from the Landlord in writing of exactly the
                  improvement or alteration and how the improvement or
                  alteration will be made.
                  {/* <div className="flex justify-center pt-5">(Page 1 of 7)</div> */}
                </li>
                <li>
                  B. Pets - Tenant{" "}
                  {lease.petsAllowed ? <span>may</span> : <span>may not</span>}
                  {} be allowed to have pets on the Premises. If pets are not
                  allowed on the premises, they are not to be allowed at
                  anytime, except licensed animals needed by the blind, deaf,
                  disabled.
                </li>
              </ul>
            </div>
            <div className="pt-2">
              The Premises are to be used only as a private residence for the
              Tenant(s) listed in Section II of this Agreement. Occupancy by
              guests for more than three (3) days is prohibited without
              Landlord's written consent and will be considered a breach of this
              Lease Agreement.
            </div>
          </section>
          <section className="pt-5">
            <span className="text-lg">V. RENT</span>
            <p className="pt-2">
              Tenant shall pay rent to the Landlord in the monthly installments
              of <span className="underline">${lease.rent}.00</span>
              <span> ({convertNumberToWords(lease.rent)} Dollars)</span>,
              payable in the name of{" "}
              <span className="underline">{landlordName}</span>. Payments are
              due on the 1st of every month (Hereinafter referred to as the “Due
              Date”) beginning{" "}
              <span className="underline">
                {DateTime.fromFormat(lease.leaseStart, "yyyy-MM-dd").toFormat(
                  "MMMM dd, yyyy"
                )}
              </span>
              . Rent payments should be mailed to:
            </p>
            {lease.hasMailingAddress ? (
              <div className="h-32 content-center my-5">
                <div className="grid justify-items-center capitalize">
                  <div>{landlordName}</div>
                  <div>{lease.mailingStreet}</div>
                  <div>{lease.mailingStreet2}</div>
                  <div>
                    {lease.mailingCity}, {lease.mailingState} {lease.mailingZip}
                  </div>
                </div>
              </div>
            ) : (
              <div className="h-32 content-center my-5">
                <div className="grid justify-items-center capitalize">
                  <div>{landlordName}</div>
                  <div>{lease.propertyStreet}</div>
                  <div>{lease.propertyStreet2}</div>
                  <div>
                    {lease.propertyCity}, {lease.propertyState}{" "}
                    {lease.propertyZip}
                  </div>
                </div>
              </div>
            )}
            <p>
              All mailed payments shall be in the form of check or money order.
              Alternatively, payments may be made in-person via cash, check,
              money order, or electronically, with prior arrangement with the
              landlord.
            </p>
            {true && (
              <p className="px-2 py-5">
                A. Prorated First Month's Rent - For the period from Tenant's
                move-in date{" "}
                <span className="underline">
                  {lease.prorateAmount
                    ? DateTime.fromFormat(
                        lease.leaseStart,
                        "yyyy-MM-dd"
                      ).toFormat("MMMM dd, yyyy")
                    : "N/A"}
                </span>{" "}
                through the end of the month, Tenant will pay to Landlord the
                prorated monthly rent of{" "}
                <span className="underline">
                  {lease.prorateAmount ? `$${lease.prorateAmount}` : " N/A "}
                </span>
                . This amount will be paid on or before the date the Tenant
                moves in.
              </p>
            )}
          </section>
          <section className="pt-5">
            <span className="text-lg html2pdf__page-break">
              VI. DEPOSITS AND CHARGES
            </span>
            <div className="pt-2">
              In addition to Rent described above, the Tenant shall pay the
              following to the items that apply:
              <ul className="grid py-5 px-2 gap-y-2">
                <span>A. Deposits (check all that apply):</span>
                <li>
                  <ul className="grid h-32 content-center pt-5 pb-3 px-5 gap-y-2">
                    {lease.securityDep && (
                      <li>- Security Deposit of ${lease.securityDep}</li>
                    )}
                    {lease.petDeposit && (
                      <li>- Pet Deposit of ${lease.petDeposit}</li>
                    )}
                    {/* {lease.lastMonthRent && (
                      <li>Last Month's Rent of ${lease.lastMonthRent}</li>
                    )}
                    {lease.advancedRent && (
                      <li>Rent in advance of ${lease.advanceRent}</li>
                    )}
                    {lease.otherRent && <li>Other ${lease.otherRent}</li>} */}
                    <li>(To be paid upon signing the Lease Agreement)</li>
                  </ul>
                  {/* <div className="flex justify-center pt-5">(Page 2 of 7)</div> */}
                  If the Tenant has paid a deposit or an advancement of rent,
                  the Landlord shall deposit the money in a separate interest
                  bearing or non-interest bearing account for the benefit of the
                  Tenant. Furthermore, the Landlord will return said deposit
                  within{" "}
                  {stateLawObj && stateLawObj.securityDeposit !== "" ? (
                    <span>{stateLawObj.securityDeposit} </span>
                  ) : (
                    <span>
                      fifteen (15) days after Tenant has vacated the premises,
                      returned keys, and provided Landlord with a forwarding
                      address.
                    </span>
                  )}
                  Landlord will give Tenant an itemized written statement of the
                  reasons for, and the dollar amount of, any of the security
                  deposit retained by the Landlord, along with a check for any
                  deposit balance.
                </li>
                <li className="h-22">
                  B. Late Charges -{" "}
                  {true ? (
                    <span>
                      If Rent has not been paid in full to the Landlord by the
                      {lease.gracePeriod ? ` ${lease.gracePeriod}` : " 5"}
                      <sup>
                        {lease.gracePeriod
                          ? getOrdinalSuffix(lease.gracePeriod)
                          : "th"}
                      </sup>{" "}
                      day after the Due Date as stated in Section V, the Rent
                      will be considered Late and the Landlord has the right to
                      charge the Tenant a late-fee that is equal to the lesser
                      of $50 or 5% of the Tenant's unpaid balance at that time.
                    </span>
                  ) : (
                    <span>Landlord agrees not to charge late fees.</span>
                  )}
                </li>
              </ul>
            </div>
          </section>
          <section className="pt-5">
            <span className="text-lg">VII. UTILITIES</span>
            <div className="pt-2">
              Tenant is responsible for a pro rata share of the following
              utility charges listed below. Each share is calculated based on
              the total number of tenants responsible for each respective
              utility bill, during each respective billing period:
              {lease.splitsBills ? (
                <ul className="grid justify-items-center content-center h-40 py-5 gap-y-2 grid-cols-2">
                  {lease.paysGas && <div>Gas</div>}
                  {lease.paysElectric && <li>Electric</li>}
                  {lease.paysWater && <li>Water</li>}
                  {lease.paysSewer && <li>Sewer</li>}
                  {lease.paysPhone && <li>Phone</li>}
                  {lease.paysInternet && <li>Internet</li>}
                  {lease.paysCable && <li>Cable</li>}
                  {lease.paysHoa && <li>HOA / Condo Fee</li>}
                </ul>
              ) : (
                <div className="flex justify-center items-center h-40">
                  All utilities are included in the price of rent
                </div>
              )}
            </div>
          </section>
          <section className="pt-5">
            <span className="text-lg">VIII. SUBLETTING & ASSIGNMENT</span>
            <p className="pt-2">
              Tenant agrees not to sublet any part of the Premises or assign
              this Lease Agreement without written consent from the Landlord.
            </p>
          </section>
          <section className="pt-5">
            <span className="text-lg">IX. MAINTENANCE</span>
            <div className="pt-2">
              Tenant agrees to keep the Premises properly maintained and in
              sanitary condition during the term of the lease. Tenant must
              return the Premises to the same level of condition as when the day
              the Tenant took occupancy.
              <ul className="grid py-5 px-2 gap-y-2">
                <li className="htlm2pdf_page-break">
                  A. Tenant to keep the premises clean, sanitary, and in good
                  condition and, upon termination of the tenancy, return the
                  premises to Landlord in a condition identical to what existed
                  when the Tenant took occupancy, except for ordinary wear and
                  tear;
                  {/* <div className="flex justify-center pt-5">(Page 3 of 7)</div> */}
                </li>
                <li>
                  B. It is the Tenant's obligation to notify Landlord
                  IMMEDIATELY of any conditions that could be hazardous in or
                  about the Premises.
                </li>
                <li>
                  C. Tenant agrees that they will be held accountable for any
                  damage made by guests on the Premises.
                </li>
              </ul>
            </div>
          </section>
          <section className="pt-5">
            <span className="text-lg">X. LANDLORD'S ACCESS</span>
            <div className="pt-2">
              Landlord or a Landlord's representative may enter the Premises
              under the following conditions:
              <ul className="grid py-5 px-2 gap-y-2">
                <li>
                  A. At anytime for the protection or preservation of the
                  Premises.
                </li>
                <li>
                  B. After notice as required by State law for the purpose of
                  repairing the Premises.
                </li>
                <li>
                  C. To inspect the Premises; make necessary or agreed-upon
                  repairs, decorations, alterations, or improvements; supply
                  agreed services: or exhibit the Premises to prospective or
                  actual purchasers, mortgagees, tenants, workers, or
                  contractors under any of the following circumstances:
                  <ul className="grid px-10 pt-5 gap-y-2">
                    <li>1. With Tenant's consent </li>
                    <li>2. In case of emergency</li>
                    <li>3. When Tenant unreasonably withholds consent.</li>
                    <li>
                      4. If Tenant is absent from the Premises for a period of
                      at least one-half a Rental Installment Period. (If the
                      rent is current and Tenant notifies Landlord of an
                      intended absence, then the Landlord may only enter with
                      Tenant's consent or for the protection or preservation of
                      the Premises.)
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>
          <section className="pt-5">
            <span className="text-lg">XI. PROHIBITED ACTS BY LANDLORD</span>
            <div className="pt-2">
              <ul className="grid px-2 gap-y-5">
                <li>
                  A. Landlord cannot cause, directly or indirectly, the
                  termination or interruption of any utility service that serves
                  the Tenant including but not limited to; refrigeration garbage
                  collection, gas, oil, electricity, lighting (interior and
                  exterior), or any other service.
                </li>
                <li>
                  B. Landlord cannot prevent the Tenant from accessing the
                  Premises by any and all means.
                </li>
                {/* <div className="flex justify-center pt-10 pb-5">
                  securityDeposit4 of 7)
                </div> */}
                <li>
                  C. Landlord cannot make any unnecessary repairs to remove;
                  windows, doors, or any fixtures. Landlord cannot remove
                  Tenant's personal property from the Premises unless Tenant has
                  not paid rent; in that case the Landlord may remove Tenant's
                  Personal Property and is not responsible for storage or
                  disposition.
                </li>
              </ul>
            </div>
          </section>
          <section className="pt-5">
            <span className="text-lg">XII. DEFAULT</span>
            <div className="pt-2">
              <ul className="grid px-2 gap-y-2">
                <span>A. TENANT'S DEFAULT</span>
                <li>
                  Tenant shall be in default if the following occurs during the
                  term of the Lease Agreement:
                  <ul className="grid px-10 py-5 gap-y-2">
                    <li>
                      1. If the Rent becomes Late as defined in Section VI, Part
                      B, and the default continues for 3 business days (business
                      days are defined as Monday through Friday except federal
                      holidays) after written notice of failure to pay rent or
                      possession of the Premises.
                    </li>
                    <li>
                      2. If there is an intentional act that causes severe
                      destruction, damage, or misuse of Property, the Landlord
                      has the authority to evict the Tenant immediately for
                      unreasonable disturbance.
                    </li>
                    <li>
                      3. If Tenant fails to perform any of the stated terms of
                      the Lease Agreement and fails to comply after seven (7)
                      days of receiving notice.
                    </li>
                  </ul>
                </li>
                <span>B. LANDLORD'S DEFAULT</span>
                <li className="my-2">
                  If Landlord does not comply with Tenant's maintenance
                  obligations within seven (7) days of written notice of
                  Landlord's default of obligation to repair, fix, or maintain
                  the Premises, the Lease Agreement may be altered;
                </li>
                <div className="html2pdf__page-break"></div>
                <span>C. WAIVER</span>
                <li className="my-2">
                  If Landlord accepts rent knowing of Tenant's default or
                  accepts performance by Tenant of any part of the Lease
                  Agreement, or, Tenant accepts performance by Landlord knowing
                  of Landlord default and pays rent, then the party accepting
                  performance shall not have the right under this Lease
                  Agreement to make a claim or terminate Lease Agreement. This
                  does not limit the rights of any party to enforce later
                  default.
                  {/* <div className="flex justify-center pt-10 pb-5">
                    (Page 5 of 7)
                  </div> */}
                  <ul className="grid px-10 py-5 gap-y-5">
                    <li>
                      1. Tenant will not be liable for rent if the Landlord's
                      failure to comply makes the Premises uninhabitable.
                    </li>

                    <li>
                      2. If the Landlord's failure to comply makes the Premises
                      habitable but not in the condition upon move-in, then the
                      rent shall be adjusted to the market value of the
                      Premises.
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>
          <section className="pt-5">
            <span className="text-lg">XIII. POSSESSION</span>
            <p className="pt-2">
              If, after authorization of this Lease Agreement by both parties
              either: A. Tenant fails to take possession of the Premises; Tenant
              is still responsible for paying rent on the Due Date every month
              and to comply with the provisions of this Lease Agreement. B.
              Landlord fails to grant possession of the Premises in a good and
              habitable condition to Tenant; The Tenant has the right to
              terminate the Lease Agreement with written notice to Landlord.
            </p>
          </section>
          <section className="pt-5">
            <span className="text-lg">XIV. NOTICES</span>
            <p className="pt-2">
              All notices made by the Tenant to the Landlord, must be delivered
              to the following address below:
            </p>
            {lease.hasMailingAddress ? (
              <div className="h-32 content-center my-5">
                <div className="grid justify-items-center capitalize">
                  <div>{landlordName}</div>
                  <div>{lease.mailingStreet}</div>
                  <div>{lease.mailingStreet2}</div>
                  <div>
                    {lease.mailingCity}, {lease.mailingState} {lease.mailingZip}
                  </div>
                </div>
              </div>
            ) : (
              <div className="h-32 content-center my-5">
                <div className="grid justify-items-center capitalize">
                  <div>{landlordName}</div>
                  <div>{lease.propertyStreet}</div>
                  <div>{lease.propertyStreet2}</div>
                  <div>
                    {lease.propertyCity}, {lease.propertyState}{" "}
                    {lease.propertyZip}
                  </div>
                </div>
              </div>
            )}
          </section>
          <section className="pt-5">
            <span className="text-lg">XV. DISCLOSURES</span>
            <p className="pt-2">
              Tenant agrees and acknowledges the disclosures attached to this
              agreement by filling in their initials below:
            </p>
            <div className="grid content-center gap-y-2 h-[180px] pl-10 py-10">
              {lease.disclosuresAddendum && (
                <div>
                  <span
                    className={`text-lg underline pr-5 ${lease.tenantFont}`}
                  >
                    {lease.tenantFont ? tenantInitials : ""}
                  </span>
                  <a
                    href={lease.disclosuresAddendum || "https://www.google.com"}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-500 hover:text-blue-700 cursor-pointer"
                  >
                    State of {lease.propertyState} Required Disclosures
                  </a>
                </div>
              )}
              {lease.rulesAddendum && (
                <div>
                  <span
                    className={`text-lg underline pr-5 ${lease.tenantFont}`}
                  >
                    {lease.tenantFont ? tenantInitials : ""}
                  </span>
                  <a
                    href={lease.rulesAddendum || "https://www.google.com"}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-500 hover:text-blue-700 cursor-pointer"
                  >
                    Tenant Rules & Regulatations
                  </a>
                </div>
              )}
              {lease.otherAddendum && (
                <div>
                  <span
                    className={`text-lg underline pr-5 ${lease.tenantFont}`}
                  >
                    {lease.tenantFont ? tenantInitials : ""}
                  </span>
                  <a
                    href={lease.otherAddendum || "https://www.google.com"}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-500 hover:text-blue-700 cursor-pointer"
                  >
                    Other Addendum
                  </a>
                </div>
              )}
              {!lease.disclosuresAddendum &&
                !lease.rulesAddendum &&
                !lease.otherAddendum && (
                  <div className="relative -left-10 flex justify-center">
                    <div>No Disclosures Attached</div>
                  </div>
                )}
            </div>
          </section>
          <section className="pt-5">
            <span className="text-lg">XVI. ADDITIONAL ADDENDUMS</span>
            <p className="pt-2">
              If any Additional addendum(s) to this agreement, is described as:
              NONE
            </p>
          </section>
          <section className="pt-5">
            <span className="text-lg">XVII. DISCLAIMER</span>
            <p className="pt-2">
              If one sentence, section, or portion of this Lease Agreement is
              deemed to be invalid, it does not affect the terms of the rest of
              this document.
            </p>
          </section>
          {/* <div className="flex justify-center pt-28 pb-5">(Page 6 of 7)</div> */}
          <section className="pt-5">
            <span className="text-lg">XVIII. TENANCY</span>
            <p className="pt-2">
              If for any reason the Tenant or Tenant's guest(s) fail to comply
              with this Lease Agreement, or the Tenant misrepresented themselves
              in this Lease Agreement or on the Rental Application, the Tenant
              may be found in violation of this Lease Agreement and at the
              Landlord's decision this document may become Void.
            </p>
          </section>
          <section className="pt-5">
            <span className="text-lg">XIX. TIME</span>
            <p className="pt-2">Is of the essence.</p>
          </section>
          <section className="pt-5">
            <span className="text-lg">XX. ENTIRE LEASE AGREEMENT</span>
            <p className="pt-2">
              This legal document supersedes any previous agreement between
              Landlord and Tenant, any other promises or agreements must be
              attached hereto other than the necessary rules and regulations as
              implied by law, have been agreed upon. Any future changes or
              modifications must be made in writing and signed by both parties.
            </p>
          </section>
          <div className="html2pdf__page-break"></div>
          <section className="pt-5">
            <span className="text-lg">XXI. AUTHORIZATION & WITNESS</span>
            <p className="pt-2">
              IN WITNESS WHEREOF, Landlord and Tenant agree to the terms and
              have executed and dated this Lease Agreement below:
            </p>
            <div id="signature" className="mt-16 pl-10">
              <div>Tenants's Name:</div>
              <div className="text-2xl capitalize">{tenantName}</div>
              <div className="pt-3">Tenants's Signature:</div>
              {lease.tenantDateSigned && (
                <>
                  <div
                    className={`text-3xl pt-2 capitalize ${lease.tenantFont}`}
                  >
                    {tenantName}
                  </div>
                  <div className="pt-3">
                    Date:{" "}
                    {DateTime.fromISO(lease.tenantDateSigned).toFormat(
                      "MM/dd/yyyy"
                    )}
                  </div>
                  <div className="text-xs">
                    {lease.tenantDateSigned}~{lease.tenantUuid}
                  </div>
                </>
              )}
            </div>
            <div className="mt-16 pl-10 relative">
              <div>Landlord's Name:</div>
              <div className="text-2xl capitalize">{landlordName}</div>
              <div className="pt-3">Landlord's Signature:</div>
              {finalSignature && (
                // only show on final signature - always hidden from pdf
                <div
                  className="absolute w-full bg-white pt-5 pb-20"
                  data-html2canvas-ignore="true"
                >
                  <div
                    className={`text-3xl pt-2 capitalize text-snappily-orange 
                  animate-bounce ${lease.landlordFont}`}
                  >
                    {landlordName}
                  </div>
                  <div className="pt-3">
                    Date:{" "}
                    {DateTime.fromISO(lease.landlordDateSigned).toFormat(
                      "MM/dd/yyyy"
                    )}
                  </div>
                </div>
              )}
              {lease.landlordDateSigned && (
                <>
                  <div
                    className={`text-3xl pt-2 capitalize ${lease.landlordFont}`}
                  >
                    {landlordName}
                  </div>
                  <div className="pt-3">
                    Date:{" "}
                    {DateTime.fromISO(lease.landlordDateSigned).toFormat(
                      "MM/dd/yyyy"
                    )}
                  </div>
                  <div className="text-xs">
                    {lease.landlordDateSigned}~{lease.landlordUuid}
                  </div>
                </>
              )}
            </div>
          </section>
          {/* <div className="flex justify-center mt-5 pt-80">(Page 7 of 7)</div> */}
        </div>
      </div>
      <div className="pb-80"></div>
    </div>
  );
};

export default LeasePDF;
